// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// 发布用
export const environment = {
  production: false,
  uat: false,
  api: 'https://twc-api-test.aritaone.com/twc-admin-information-api/v1',
  authApi: 'https://twc-api-test.aritaone.com/twc-admin-auth-api/v1',
  activityApi: 'https://twc-api-test.aritaone.com/twc-admin-activity-api/v1',
  memberApi: 'https://twc-api-test.aritaone.com/twc-admin-member-api/v1',
};

// lin本地联调用
// const url = 'http://twcadmin.test.com';
// export const environment = {
//   production: false,
//   uat: false,
//   api: `${url}:8083/twc-admin-information-api/v1`,
//   authApi: `${url}:8081/twc-admin-auth-api/v1`,
//   activityApi: `${url}:8082/twc-admin-activity-api/v1`,
//   memberApi: `${url}:8084/twc-admin-member-api/v1`,
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
